import { useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchSurveyResponse = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchSurveyResponse = useCallback(async (surveyId, assignapp_id, assignapp_questionnaire_id) => {
    if (!surveyId || !assignapp_id || !assignapp_questionnaire_id) return;

    if (typeof surveyId !== "string") {
      setResponse({
        data: null,
        error: { message: "surveyId inválido al consultar respuestas del cuestionario" },
      });
      return;
    }

    startLoading();
    const response = await apiGet(`/surveys/${surveyId}/responses/find_by_assignapp_id`, "Error al obtener la respuesta del cuestionario", {
      id: assignapp_id,
      assignapp_questionnaire_id,
    });

    if (!response) {
      setResponse({ data: [], error: null });
      return;
    }

    setResponse({ data: response.data, error: response.error });
    return response.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { fetchSurveyResponse, data, loading, error };
};

export default useFetchSurveyResponse;
